import { Action } from '@/_core/fluxstore/types';
import { useLocalStorage } from 'vue-composable';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetReleaseIsCollapsed extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetReleaseIsCollapsed';

    public constructor(public id: string, public isCollapsed: boolean) {
        super(SetReleaseIsCollapsed.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetReleaseIsCollapsed): Promise<boolean> => {
    const { storage: collapsedReleaseIds } = useLocalStorage(`_storiesonboard_${state.id}_collapsedReleaseIds`, []);
    if (action.isCollapsed && !collapsedReleaseIds.value.includes(action.id)) {
        collapsedReleaseIds.value.push(action.id);
    } else if (!action.isCollapsed && collapsedReleaseIds.value.includes(action.id)) {
        collapsedReleaseIds.value = collapsedReleaseIds.value.filter((x) => x !== action.id);
    }

    return true;
};

const reducer = (state: StorymapState, action: SetReleaseIsCollapsed): void => {
    const release = state.releases.find((x) => x.id === action.id);

    release.isCollapsed = action.isCollapsed;
};

//@ts-ignore
registerMiddleware(SetReleaseIsCollapsed.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetReleaseIsCollapsed.ACTION_TYPE, reducer);
